// extracted by mini-css-extract-plugin
export default {"wrap":"ChangeLanguage_wrap__Z+O3o","flag":"ChangeLanguage_flag__tNXv1"};